import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Phone, ArrowRight } from "lucide-react";
export default function PortCharlotteFreeInspectionCta() {
  return <section id="port-charlotte-free-inspection-cta" className="bg-primary text-primary-foreground py-16 md:py-24 w-full">
      <div className="container mx-auto px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default mb-6 leading-tight">
            Schedule Your Free Inspection Today!
          </h2>
          <p className="text-lg md:text-xl text-primary-foreground/80 mb-10 font-default">
            Don't let pests take over your home or business. Get a comprehensive inspection and a customized treatment plan tailored to your specific needs today. Limited slots available – act now!
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-8">
            <div className="flex items-center gap-3 text-xl md:text-2xl font-semibold font-default">
              <div className="bg-accent/20 p-3 rounded-full">
                <Phone className="w-6 h-6 text-accent" />
              </div>
              <span>Call Us Today: 941-888-0485</span>
            </div>
            
            <span className="hidden sm:block text-primary-foreground/30 text-2xl">
              |
            </span>
            
            <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 font-default text-lg px-10 h-16 rounded-full shadow-xl uppercase tracking-wider transition-transform hover:scale-105">
              <Link to="/ContactPage">
                Get Your Free Inspection Quote Now
                <ArrowRight className="ml-2 w-6 h-6" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}